<div class="pag-container">

  <app-campaign-3-breadcrumb
    #breadcrumbComponent
    *ngIf="showBreadCrumb"
    [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)"
    homeLink="">
  </app-campaign-3-breadcrumb>

  <!-- Titolo pagina -->
<div class="header-row">
  <h1 class="bold-text header-blue">
    {{ 'baskets.articlesList' | translate }}
  </h1>

  <button
    pButton
    type="button"
    class="k-generic-btn"
    icon="fa fa-angle-left"
    iconPos="left"
    (click)="onGoBack()"
    [label]="'common.back' | translate">
  </button>
</div>

<!--   <h3 class="thin-text header-blue">
    {{ 'baskets.articlesList_descr' | translate }} {{ routeParams }}
  </h3> -->

  <!-- Tabella articoli -->
  <div class="ui-g-12" *ngIf="showTable">

    <app-campaign-3-kontable
      #basketArticlesKontable
      [columns]="[
        { field: 'id', title: 'baskets.id', filterType: textFilter, bodyTemplate: idTemplate },
       
        { field: 'description', title: 'baskets.description', filterType: textFilter },
        { field: 'host_code', title: 'baskets.code', filterType: textFilter },
        { field: 'barcode', title: 'baskets.barcode', filterType: textFilter },
        { field: 'product_categories', title: 'baskets.product_categories', filterType: textFilter },
        { field: 'product_department', title: 'baskets.product_department', filterType: textFilter }

      ]"

      [paginationType]="paginationType"
      [showInfoButton]="false"
      [showDetailsButton]="false"
      [showRecoverButton]="false"
      [showAddButton]="false"
      [showDeleteButton]="false"
      [showEditButton]="false"
      [allowSelectRow]="false"
      [additionalRowCommands]="rowActions"
      [filterBySingleColumn]="true"
      [source]="basketArticles">

      <!-- Status -->
      <ng-template #idTemplate let-row>
        <span class="center-number">
          {{ row.id }}
        </span>
      </ng-template>

      <!-- Azioni riga  DETTAGLIO ->KS-7676 disabilitato-->
      <!-- <ng-template #rowActions let-row>
        <div class="d-flex justify-content-center">
          <button
            pButton
            type="button"
            class="roundedButton row-buttom-margin"
            icon="pi pi-eye"
            (click)="goToArticle(row)"
            [attr.data-testid]="'goToArticle' + row.id"
            pTooltip="{{ 'baskets.goToArticle' | translate }}">
          </button>
        </div>
      </ng-template>-->

    </app-campaign-3-kontable>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/baskets/basket-articles/basket-articles.component.html